export function formatMarketUid(marketUid: string): string {
  return marketUid && marketUid.replace(/-/, '_').toUpperCase();
}
